import { useQuery } from '@tanstack/react-query'

import { CarbonLabAPI } from '@cibo/core'

export const useCarbonLabPractices = (collectionId?: string) => {
  return useQuery(['carbonLab.practices'], () => CarbonLabAPI.practices())
}
